var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F7F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14,
    fill: "#0516C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 11.25H12.375C12.0766 11.25 11.7905 11.3685 11.5795 11.5795C11.3685 11.7905 11.25 12.0766 11.25 12.375V23.625C11.25 23.9234 11.3685 24.2095 11.5795 24.4205C11.7905 24.6315 12.0766 24.75 12.375 24.75H23.625C23.9234 24.75 24.2095 24.6315 24.4205 24.4205C24.6315 24.2095 24.75 23.9234 24.75 23.625V12.375C24.75 12.0766 24.6315 11.7905 24.4205 11.5795C24.2095 11.3685 23.9234 11.25 23.625 11.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 20.625L18.75 22.125L21.75 18.375M14.25 14.625H21.75M14.25 17.625H17.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.be703531009beda972ff61f83b3f09af.svg";
export { ForwardRef as ReactComponent };